import { useTheme } from "@mui/material";
import { styled } from "@mui/material/";
import { ConfigProvider, DatePicker as AntDatePicker, GetProps } from "antd";

type RangePickerProps = GetProps<typeof AntDatePicker.RangePicker>;

const StyledDatePicker = styled(AntDatePicker.RangePicker)(({ theme }) => {
  return {
    height: "3rem",
    width: "16rem",
    fontSize: "1.2rem",

    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    },

    ".anticon": {
      color: theme.palette.text.primary,
    },

    ".ant-picker-input": {
      color: theme.palette.text.primary,
    },

    ".ant-picker-input input::placeholder": {
      color: theme.palette.text.secondary,
    },
  };
});

export const DateRangePicker: React.FC<RangePickerProps> = (props) => {
  const theme = useTheme();

  return (
    <ConfigProvider
      theme={{
        components: {
          DatePicker: {
            activeBg: theme.palette.background.paper,
            activeBorderColor: theme.palette.brandedTypography.textColor,
            colorBgElevated: theme.palette.background.paper,
            colorText: theme.palette.text.primary,
            colorTextDisabled: theme.palette.text.disabled,
            cellActiveWithRangeBg: theme.palette.datePicker.selectedRange,
            colorPrimary: theme.palette.datePicker.selectedItem,
            colorTextLightSolid: theme.palette.datePicker.selectedItemText,
            cellHoverBg: theme.palette.datePicker.presetCellHoverBg,
            colorTextPlaceholder: theme.palette.text.secondary,
            colorTextHeading: theme.palette.text.primary,
            colorIcon: theme.palette.text.primary,
            colorIconHover: theme.palette.text.secondary,
            hoverBorderColor: theme.palette.datePicker.borderColor,
          },
        },
      }}
    >
      <StyledDatePicker {...props} />
    </ConfigProvider>
  );
};

export default DateRangePicker;
